import React,{useState} from 'react'
import TimeDifference from '../../common/TimeDifference'
import clsx from 'clsx'
function ActivityListItem({item}) {
   const [isExpanded,setIsExpanded] = useState(false)
   const statusNames = ["Waiting","Resend","Queued","Sent","Failed","Delivered","Undelivered","Rejected","Read"]
   const statusBadges = ["white","dark","light","success","danger","info","warning","danger","success"] 

   return (
   <>
   <tr>
    <td>{item.id}</td>
    <td>{item.activityName}</td>
    <td> <span className={clsx("badge",`badge-${statusBadges[item.status]}`)}>{statusNames[item.status]}</span> </td>
    <td>{item.category}</td>
   
    <td>
        <button className='btn btn-secondary btn-sm rounded' onClick={()=>setIsExpanded(!isExpanded)}>
            {isExpanded ? '-' : '+'}
        </button>
    </td>
   </tr>
   {isExpanded?<tr>
        <td></td>
        <td colSpan={3}>
        <div className="collapse show p-3 rounded" style={{backgroundColor:"#e9ecef"}}>
            <div className="d-flex justify-content-between align-items-center">
                     <div className='d-flex flex-column'>
                      <span><small>Patient Id : {item.patientId}</small></span>
                      <span><small>First Name : {item.firstName}</small></span>
                      <span><small>Last Name : {item.lastName}</small></span>
                      <span><small>Preferred Name : {item.preferredName}</small></span>
                      <span><small>Full Patient Name : {item.patientName}</small></span>
                      <span><small>Medium Type : {item.mediumType}</small></span>
                      <span><small>Category : {item.category}</small></span>
                      <span><small>Queue Id : {item.queueId}</small></span>
                      <span><small>Content Path : {item.content}</small></span>
                      <span><small>Activity : {item.activityName}</small></span>
                      <span><small>Extra Info : {item.extraInfo}</small></span>
                       <span><small>Created At : {item.createdAt}</small></span>
                      <span><small>Modified At : {item.modifiedAt}</small></span>
                    </div>
            
            <div>
                <button className="btn btn-sm btn-primary" >Preview Email</button>
             </div>
             </div>
        </div>
        </td>
        <td></td>

    </tr>:""}
   </>
  )
}

export default ActivityListItem